// extracted by mini-css-extract-plugin
export default {"page":"cowew","container":"yILdS ZdH1P"};